import { TaskStatusDto, TaskTriggerDto, UserRoleDto } from '@/api/generated';
import { LandingPageTranslation } from '@/assets/locales/views/landingPage/landingPage.translation.en.ts';

export const landingPageTranslation: LandingPageTranslation = {
  dashboard: {
    activeSession: 'Aktywna sesja',
    activity: {
      continue: 'Kontynuuj',
      learnMore: 'Zapoznaj się',
    },
    aiAssistant: {
      label: 'Asystent Rozwoju AI',
    },
    employee: {
      activitiesTitle: 'MOJE AKTYWNOŚCI ROZWOJOWE',
      awaitingSupervisorDescription:
        'Twój przełożony przygotowuje Twój plan rozwoju. Damy Ci znać, gdy będzie można dodać kroki.',
      awaitingSupervisorTitle: 'Przełożony przygotowuje Twój plan',
      createPlan: 'Określ kierunek rozwoju',
      dcFeedbackDescription:
        'Plan założysz, gdy zostanie odnotowane Twoje spotkanie feedbackowe po sesji Development Center.',
      dcFeedbackTitle: 'Czekasz na feedback po DC',
      moreActivities: '+ {{count}} więcej aktywności',
      moreTasks: '+ {{count}} więcej zadań',
      myDevelopment: 'Mój rozwój',
      myProfile: 'Mój profil',
      noActivities: 'Brak aktywności rozwojowych',
      noPlanDesc:
        'Twój plan rozwojowy nie został jeszcze aktywowany. Skontaktuj się z przełożonym.',
      noPlanTitle: 'Brak aktywnego planu rozwoju',
      noStepsDescription: 'Dodaj pierwszy krok, aby rozpocząć śledzenie postępu planu.',
      noStepsTitle: 'Rozpocznij pracę nad planem',
      noTasks: 'Brak zadań',
      pausedDescription:
        'Nie jesteś obecnie objęty cyklem rozwojowym, więc nie możesz utworzyć planu. Wróć tu, gdy obejmie Cię kolejny cykl.',
      pausedTitle: 'Poza cyklem rozwojowym',
      planTitle: 'MÓJ PLAN ROZWOJU',
      subtitle: 'jako pracownik',
      tasksTitle: 'MOJE NAJBLIŻSZE ZADANIA',
      title: 'Moje zadania i rozwój',
    },
    greeting: 'Cześć',
    hrbp: {
      areaHint: 'Obszar obejmuje {{count}} pracowników',
      changes: {
        absenceReturns: 'Powroty z absencji (3+ tyg)',
        details: {
          absenceReturnsScope: '{{count}} os. / 14 dni',
          absenceReturnsTitle: 'Powroty z absencji',
          dateTo: 'Data do',
          employee: 'Pracownik',
          empty: 'Brak danych w tym oknie.',
          endingContractsScope: '{{count}} os. / 30 dni',
          endingContractsTitle: 'Kończące się umowy',
          headcountTitle: 'Zatrudnienie - ostatnie 2 tygodnie',
          moreContracts: '+ {{count}} innych umów...',
          moreReturns: '+ {{count}} innych powrotów...',
          returnDate: 'Powrót',
        },
        empty: 'Brak zmian kadrowych w Twoim obszarze.',
        endingContracts: 'Kończące się umowy (30 dni)',
        headcount: 'Zatrudnienie aktualne',
        title: 'Zmiany kadrowe',
      },
      goToArea: 'Podległy obszar HR',
      goToSuccession: 'Sukcesja',
      kpi: {
        agedFiftyFivePlus: 'Wiek 55+',
        employees: 'Pracownicy w obszarze',
        highRiskOfLeaving: 'Wysokie ryzyko odejścia',
        inDevelopmentPrograms: 'W programach rozwoju',
        leadershipPotential: 'Potencjał liderski',
        ready1To2Years: 'Gotowi 1-2 lata',
        ready3To5Years: 'Gotowi 3-5 lat',
        readyNow: 'Gotowi teraz',
        readyUpTo1Year: 'Gotowi do 1 roku',
      },
      reactions: {
        empty: 'Nic nie wymaga teraz Twojej reakcji.',
        highRiskOfLeaving: 'Wysokie ryzyko odejścia: {{count}} osób',
        title: 'Wymaga reakcji',
        withoutPlan: 'Brak aktywnego planu: {{count}} osób',
      },
      subtitle: 'jako HRBP',
      title: 'Sukcesja, rozwój i kadry w podległym obszarze',
    },
    manager: {
      approve: 'Zatwierdź',
      birthdays: 'Urodziny',
      birthdaysTitle: 'Zbliżające się urodziny',
      fullOverview: 'Pełny przegląd · {{count}} osób',
      kpi: {
        noPlan: 'Brak planu rozwoju',
        overdueSteps: 'Zaległych kroków',
        plansToApprove: 'Planów do zatwierdzenia',
        teamSize: 'Osób w zespole',
      },
      myTeam: 'Mój zespół',
      needsReaction: 'Wymaga reakcji',
      noActivityDays: 'Brak aktywności od {{count}} dni',
      noAttention: 'Nic nie wymaga teraz Twojej reakcji.',
      noDevelopmentPlan: 'Brak planu rozwoju',
      onTrack: '{{count}} osób realizuje plan zgodnie z harmonogramem',
      overdueDaysAgo: '{{count}} dni po terminie',
      overdueStep: 'Krok zaległy',
      planToApprove: '{{name}}: plan do zatwierdzenia',
      subtitle: 'jako przełożony',
      teamState: 'Stan zespołu',
      title: 'Rozwój mojego zespołu',
      today: 'Dziś',
      tomorrow: 'Jutro',
      waitingDays: 'Czeka od {{count}} dni',
      yesterday: 'Wczoraj',
    },
    news: {
      add: 'Zarządzaj',
      all: 'Wszystkie',
      backToList: 'Wróć do listy',
      backToStart: 'Wróć na Start',
      close: 'Zamknij',
      development: 'Rozwój',
      empty: 'Brak aktualności w tej kategorii.',
      emptyContent: 'Brak treści artykułu.',
      error: 'Nie udało się załadować aktualności.',
      hideOlder: 'Ukryj starsze artykuły',
      loading: 'Ładowanie artykułu...',
      openInHub: 'Otwórz w bazie aktualności',
      readMore: 'Czytaj więcej',
      share: 'Udostępnij',
      shareError: 'Nie udało się udostępnić artykułu',
      shareLinkCopied: 'Skopiowano link do artykułu',
      showing: '{{visible}} z {{total}}',
      showOlder: 'Pokaż starsze artykuły',
      title: 'Aktualności',
      tutorials: 'Tutoriale',
      updates: 'Aktualizacje',
      videoError:
        'Nie można odtworzyć tego wideo. Plik może być uszkodzony albo niepoprawnie zakodowany.',
      yesterday: 'Wczoraj',
    },
    noRoles: 'Brak przypisanych ról. Skontaktuj się z administratorem.',
    notifications: 'powiadomienia',
    platformStats: {
      entriesUnit: 'wejść',
      subtitle: 'Łącznie od uruchomienia jAIn',
      title: 'Wejścia na platformę',
    },
    roles: {
      admin: 'Administrator',
      employee: 'Pracownik',
      hrbp: 'HRBP',
      manager: 'Przełożony',
    },
    selectRoleHint: 'Wybierz co najmniej jedną rolę, aby zobaczyć widok.',
    subtitle: 'Twoje centrum pracy jAIn 3.0',
    task: {
      status: {
        overdue: 'Przeterminowane',
        [TaskStatusDto.Cancelled]: 'Anulowane',
        [TaskStatusDto.Done]: 'Zakończone',
        [TaskStatusDto.InProgress]: 'W toku',
        [TaskStatusDto.Open]: 'Nowe',
      },
      type: {
        [TaskTriggerDto.DevelopmentPlanInitiationRequired]: 'Inicjacja planu',
        [TaskTriggerDto.DevelopmentPlanRequired]: 'Wymagany plan',
        [TaskTriggerDto.DevelopmentPlanReviewRequired]: 'Plan do akceptacji',
        [TaskTriggerDto.DevelopmentStepInProgress]: 'Krok w realizacji',
        [TaskTriggerDto.DevelopmentStepOverdue]: 'Krok po terminie',
        [TaskTriggerDto.Manual]: 'Zadanie',
      },
    },
    yourRoles: 'TWOJE ROLE',
  },
  finalStatement: {
    subtitle: 'To inteligentny partner',
    title: 'jAIn to nie kolejny system',
  },
  hero: {
    buttonText: {
      Employee: 'Przejdź do swojego profilu',
      [UserRoleDto.Admin]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.AdminCertification]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.AdminDevelopment]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.AdminSuccession]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.Employee]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.Hrbp]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.HrbpHq]: 'Przejdź do wyszukiwarki pracowników',
      [UserRoleDto.ManagerP1]: 'Przejdź do swojego zespołu',
      [UserRoleDto.ManagerP2]: 'Przejdź do swojego zespołu',
    },
    learnMore: 'Dowiedz się więcej',
    rotatingTexts: {
      Employee: ['spersonalizowane plany rozwojowe', 'chat rozwojowy z asystentem AI'],
      [UserRoleDto.Admin]: [
        'wygodną wyszukiwarkę pracowników',
        'interaktywny moduł zarządzania sukcesją',
        'fiszki pracowników',
        'podsumowanie informacji po MDR',
        'status planów rozwojowych',
        'chat rozwojowy o pracowniku',
      ],
      [UserRoleDto.AdminCertification]: ['wygodną wyszukiwarkę pracowników', 'fiszki pracowników'],
      [UserRoleDto.AdminDevelopment]: [
        'wygodną wyszukiwarkę pracowników',
        'fiszki pracowników',
        'podsumowanie informacji po MDR',
        'status planów rozwojowych',
        'chat rozwojowy o pracowniku',
      ],
      [UserRoleDto.AdminSuccession]: [
        'wygodną wyszukiwarkę pracowników',
        'interaktywny moduł zarządzania sukcesją',
        'fiszki pracowników',
      ],
      [UserRoleDto.Employee]: [
        'spersonalizowane plany rozwojowe',
        'chat rozwojowy z asystentem AI',
      ],
      [UserRoleDto.Hrbp]: [
        'wygodną wyszukiwarkę pracowników',
        'interaktywny moduł zarządzania sukcesją',
        'fiszki pracowników',
        'podsumowanie informacji po MDR',
        'status planów rozwojowych',
        'chat rozwojowy o pracowniku',
      ],
      [UserRoleDto.HrbpHq]: [
        'wygodną wyszukiwarkę pracowników',
        'interaktywny moduł zarządzania sukcesją',
        'fiszki pracowników',
        'podsumowanie informacji po MDR',
        'status planów rozwojowych',
        'chat rozwojowy o pracowniku',
      ],
      [UserRoleDto.ManagerP1]: [
        'fiszki pracowników',
        'podsumowanie informacji po MDR',
        'status planów rozwojowych',
      ],
      [UserRoleDto.ManagerP2]: [
        'fiszki pracowników',
        'podsumowanie informacji po MDR',
        'status planów rozwojowych',
      ],
    },
    subtitle: 'Poznaj jAIn i odkryj',
    title: 'Doświadcz nowych możliwości rozwoju',
    welcomeText: 'Hej, ',
  },
  ourNeeds: {
    hrDatabase: {
      description: {
        Employee: '',
        [UserRoleDto.Admin]:
          'Zarządzaj danymi z jednego miejsca. jAIn porządkuje, analizuje i prezentuje dane w sposób, który wspiera twoje decyzje HR.',
        [UserRoleDto.AdminCertification]:
          'Zarządzaj danymi z jednego miejsca. jAIn porządkuje, analizuje i prezentuje dane w sposób, który wspiera twoje decyzje HR.',
        [UserRoleDto.AdminDevelopment]:
          'Zarządzaj danymi z jednego miejsca. jAIn porządkuje, analizuje i prezentuje dane w sposób, który wspiera twoje decyzje HR.',
        [UserRoleDto.AdminSuccession]:
          'Zarządzaj danymi z jednego miejsca. jAIn porządkuje, analizuje i prezentuje dane w sposób, który wspiera twoje decyzje HR.',
        [UserRoleDto.Employee]: '',
        [UserRoleDto.Hrbp]:
          'Zarządzaj danymi z jednego miejsca. jAIn porządkuje, analizuje i prezentuje dane w sposób, który wspiera twoje decyzje HR.',
        [UserRoleDto.HrbpHq]:
          'Zarządzaj danymi z jednego miejsca. jAIn porządkuje, analizuje i prezentuje dane w sposób, który wspiera twoje decyzje HR.',
        [UserRoleDto.ManagerP1]:
          'Zyskaj szybki dostęp do danych swojego zespołu. jAIn wspiera Ciebie - a Ty widzisz to, co ważne.',
        [UserRoleDto.ManagerP2]:
          'Zyskaj szybki dostęp do danych swojego zespołu. jAIn wspiera Ciebie - a Ty widzisz to, co ważne.',
      },
      title: 'Ogromna baza danych HR',
    },
    newRole: {
      description: {
        Employee:
          'Budujesz i podążasz za swoim planem rozwojowym. jAIn podpowiada, jak go zrealizować i co pomoże Ci zrobić kolejny krok.',
        [UserRoleDto.Admin]:
          'Monitoruj gotowość pracowników do objęcia nowych ról i odpowiedzialności. Wspieraj rozwój kompetencji w całej organizacji - systemowo.',
        [UserRoleDto.AdminCertification]:
          'Monitoruj gotowość pracowników do objęcia nowych ról i odpowiedzialności. Wspieraj rozwój kompetencji w całej organizacji - systemowo.',
        [UserRoleDto.AdminDevelopment]:
          'Monitoruj gotowość pracowników do objęcia nowych ról i odpowiedzialności. Wspieraj rozwój kompetencji w całej organizacji - systemowo.',
        [UserRoleDto.AdminSuccession]:
          'Monitoruj gotowość pracowników do objęcia nowych ról i odpowiedzialności. Wspieraj rozwój kompetencji w całej organizacji - systemowo.',
        [UserRoleDto.Employee]:
          'Budujesz i podążasz za swoim planem rozwojowym. jAIn podpowiada, jak go zrealizować i co pomoże Ci zrobić kolejny krok.',
        [UserRoleDto.Hrbp]:
          'Monitoruj gotowość pracowników do objęcia nowych ról i odpowiedzialności. Wspieraj rozwój kompetencji w całej organizacji - systemowo.',
        [UserRoleDto.HrbpHq]:
          'Monitoruj gotowość pracowników do objęcia nowych ról i odpowiedzialności. Wspieraj rozwój kompetencji w całej organizacji - systemowo.',
        [UserRoleDto.ManagerP1]:
          'Wyznaczaj kierunki planów i wspieraj rozwój zespołu. jAIn podpowie, kto jest gotowy na nowe wyzwania.',
        [UserRoleDto.ManagerP2]:
          'Wyznaczaj kierunki planów i wspieraj rozwój zespołu. jAIn podpowie, kto jest gotowy na nowe wyzwania.',
      },
      title: 'Rozwój i gotowość do nowych ról',
    },
    successionModule: {
      description: {
        Employee: '',
        [UserRoleDto.Admin]:
          'Zarządzaj strukturą. Przewiduj zmiany. Zapewnij ciągłość. jAIn pozwala tworzyć i modyfikować struktury organizacyjne w czasie rzeczywistym - intuicyjnie i przejrzyście.',
        [UserRoleDto.AdminCertification]: '',
        [UserRoleDto.AdminDevelopment]: '',
        [UserRoleDto.AdminSuccession]:
          'Zarządzaj strukturą. Przewiduj zmiany. Zapewnij ciągłość. jAIn pozwala tworzyć i modyfikować struktury organizacyjne w czasie rzeczywistym - intuicyjnie i przejrzyście.',
        [UserRoleDto.Employee]: '',
        [UserRoleDto.Hrbp]:
          'Manage the structure. Anticipate changes. Ensure continuity. jAIn allows you to create and modify organizational structures in real time - intuitively and transparently.',
        [UserRoleDto.HrbpHq]:
          'Manage the structure. Anticipate changes. Ensure continuity. jAIn allows you to create and modify organizational structures in real time - intuitively and transparently.',
        [UserRoleDto.ManagerP1]: '',
        [UserRoleDto.ManagerP2]: '',
      },
      title: 'Zarządzanie sukcesją',
    },
    title: 'Nasze potrzeby',
  },
  stats: {
    andCounting: 'i stale rośnie...',
    bePartOfSuccess: 'Bądź częścią tej historii sukcesu!',
    communityDescription: 'Jesteśmy dumni z liczby użytkowników, którzy nam zaufali',
    createdByUsers: 'utworzone przez użytkowników',
    joinOurCommunity: 'Dołącz do naszej społeczności',
    title: 'jAIn w liczbach',
    totalDevelopmentPlans: 'Plany rozwojowe',
    totalVisits: 'Liczba odwiedzin',
    trustMessage: 'Dołącz do rosnącej społeczności profesjonalistów',
  },
  whyJain: {
    description: {
      accented: 'dane, rozwój i gotowość organizacji',
      firstPart: 'Tworzymy przestrzeń, w której ',
      secondPart: ' na każdą zmianę spotykają się w jednym miejscu.',
    },
    title: 'Dlaczego jAIn?',
  },
};
